if (!customElements.get('cv-creator-videos')) {
  customElements.define('cv-creator-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.rail = this.querySelector('.cv-videos-rail');
      this.abortController = new AbortController();
      const listenerOptions = {signal: this.abortController.signal};
      this.addEventListener('click', (event) => {
        const arrow = event.target.closest('[data-cv-scroll]');
        if (arrow) {
          const card = this.querySelector('.cv-video-card');
          this.rail.scrollBy({
            left: Number(arrow.dataset.cvScroll) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).gap || 0)),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
          return;
        }
        const play = event.target.closest('.cv-video-play');
        if (!play) return;
        const frame = play.parentElement;
        const video = frame.querySelector('video');
        if (!video) return;
        this.pauseOthers(video);
        if (!video.src) {
          video.src = video.dataset.cvSrc;
          video.controls = true;
          video.hidden = false;
          video.load();
        }
        video.muted = false;
        frame.closest('.cv-video-card').querySelector('.cv-video-error').hidden = true;
        play.hidden = true;
        frame.querySelector('.cv-video-poster')?.setAttribute('hidden', '');
        video.focus();
        video.play().catch((error) => {
          play.hidden = false;
          video.hidden = true;
          frame.querySelector('.cv-video-poster')?.removeAttribute('hidden');
          if (error.name !== 'AbortError') this.showError(video);
        });
      }, listenerOptions);
      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', () => {
          this.pauseOthers(video);
        }, listenerOptions);
        video.addEventListener('playing', () => {
          video.parentElement.querySelector('.cv-video-poster')?.setAttribute('hidden', '');
          video.parentElement.querySelector('.cv-video-play').hidden = true;
        }, listenerOptions);
        video.addEventListener('error', () => this.showError(video), listenerOptions);
      });
      this.querySelectorAll('.cv-video-poster').forEach((poster) => {
        poster.addEventListener('error', () => {
          poster.hidden = true;
          poster.closest('.cv-video-frame')?.classList.add('cv-video-frame--poster-fallback');
        }, listenerOptions);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(({target, isIntersecting}) => { if (!isIntersecting) this.pauseFrame(target); });
        }, {threshold: 0.15});
        this.querySelectorAll('.cv-video-frame').forEach((frame) => this.observer.observe(frame));
      }
      this.visibilityHandler = () => {
        if (document.hidden) this.pauseOthers();
      };
      document.addEventListener('visibilitychange', this.visibilityHandler, listenerOptions);
    }
    showError(video) {
      video.closest('.cv-video-card').querySelector('.cv-video-error').hidden = false;
      video.parentElement.querySelector('.cv-video-play').hidden = false;
      video.hidden = true;
      video.parentElement.querySelector('.cv-video-poster')?.removeAttribute('hidden');
    }
    pauseFrame(frame) {
      frame.querySelector('video')?.pause();
    }
    pauseOthers(activeVideo) {
      document.querySelectorAll('cv-creator-videos video').forEach((video) => { if (video !== activeVideo) video.pause(); });
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach((video) => video.pause());
      this.observer?.disconnect();
      this.abortController?.abort();
      this.initialized = false;
    }
  });
}
